<div class="info__container">
    <div class="info__content">
        {{info}}
    </div>
    <div class="info__buttons">
        <button class="btn--type2" (click)="closeDialog()">
            <span>{{buttonText}}</span>
        </button>
    </div>
</div>